import { SuccessStories } from "../../types/successStory";

export const successStories: SuccessStories[] = [
    {
      title: 'Dématérialisation et Archivage Numérique',
      company: 'Total Energies',
      description: 'success_story_text_2',
      image: '/assets/img/ess.png',
      link: 'https://emraldsecuritiesservices.com/',
      domain: 'Compagnie pétrolière',
      country: 'Cameroun',
      illustration: '/assets/img/home/plateforme-petroliere.jpeg',
      cleint_logo: '/assets/clients/Logo_TotalEnergies.png'
    },
    {
      title: "Conception d'application",
      company: 'CUD',
      description: '',
      image: '/assets/services/ged.jpg',
      link: '#',
      domain: 'Service publique',
      country: 'Cameroun',
      cleint_logo: '/assets/clients/logo_cud_tranparent.png',
      illustration: '/assets/img/home/rhone-poulenc.jpg'
    },
    {
      cleint_logo: '/assets/clients/air-liquide.svg',
      title: "Conception d'application",
      company: 'PERENCO',
      description: 'success_story_text_3',
      image: '/assets/services/api.png',
      link: '#',
      domain: 'Compagnie pétrolière',
      country: 'Cameroun',
      illustration: '/assets/img/home/plateforme-petroliere.jpeg'
    },
    {
      title: "Fourniture d'équipement et Licences",
      cleint_logo: '/assets/clients/afrexim-bank.jpeg',
      company: 'AFREXIMBANK',
      description: 'success_story_text_4',
      image: '/assets/services/cloud.png',
      link: '#',
      domain: 'Banque',
      country: 'Cameroun',
      illustration: '/assets/img/home/banque.jpg'
    },
    {
      title: "Conception d'application mobile",
      cleint_logo: '/assets/clients/cadyst.png',
      company: 'CADYST',
      description: 'success_story_text_4',
      image: '/assets/clients/cadyst-usine.jpeg',
      illustration: '/assets/clients/cadyst-usine.jpeg',
      link: '#',
      domain: 'Agroalimentaire',
      country: 'Cameroun'
    },
    {
      cleint_logo: '/assets/clients/logo_rullier.jpeg',
      title: 'Refonte site e-commerce',
      company: 'RULLIER BOIS',
      description: 'success_story_text_4',
      image: '/assets/services/cloud.png',
      link: '#',
      domain: 'Bois et dérivés pour la construction',
      country: 'France',
      illustration: '/assets/clients/rullier-bois.jpeg'
    },
    {
      cleint_logo: '/assets/clients/ess-logo.svg',
      title: 'Site internet',
      company: 'ESS',
      description: 'success_story_text_1',
      image: '/assets/clients/ess-logo.svg',
      link: '#',
      domain: 'Groupe camerounais indépendant d’établissements financiers et d’investissement',
      country: 'Cameroun',
      illustration: '/assets/img/ess.png'
    },
    {
      cleint_logo: '/assets/clients/ellios.png',
      title: 'Site internet',
      company: 'ELLIOS',
      description: 'success_story_text_4',
      image: '/assets/clients/high-security-safe.jpeg',
      link: '#',
      domain: 'La surveillance humaine, la surveillance par des systèmes électroniques de sécurité ou de gardiennage, de transport de fonds.',
      country: 'Cameroun',
      illustration: '/assets/clients/high-security-safe.jpeg'
    }
  ];